<template>
<div>

  <div>
    <nav class="z-depth-0 row" style="background:#2a2a2a">
    <div class="nav-wrapper col s12">
      <router-link  to="/" style="color:white;font-weight:600"><a class="brand-logo logo-wrapper"><img src="./assets/logo.png" class="logo" /></a></router-link>
      <a data-target="mobile-nav" class="sidenav-trigger"><i class="material-icons" style="color:#888">menu</i></a>
      <ul class="right hide-on-med-and-down action-links" >
        <li ><router-link  to="/" style="color:white;font-weight:600">Home</router-link></li>
        <li >
          <a class="dropdown-trigger btn z-depth-0" data-target='dropdown1'>Services</a>
          <ul id='dropdown1' class='dropdown-content'>
              <li v-for="(name) of listItems" v-bind:key="name">
                <router-link :to="{ name: 'services', params: {service: name } }" style="color:#000000;font-weight:400">{{ name }}</router-link>
              </li>
          </ul>
        </li>
        <li @click="toggleDropDown()"><router-link  to="/about" style="color:white;font-weight:600">About</router-link></li>
        <li ><router-link  to="/contact" style="color:white;font-weight:600">Contact</router-link></li>
        <li ><router-link  to="/policy" style="color:white;font-weight:600">Privacy Policy</router-link></li>
        <li ><a href="https://panel.kcco.co.in/" style="color:white;font-weight:600">Login</a></li>
      </ul>
    </div>
  </nav>

   <ul class="sidenav" id="mobile-nav">
     <li class="mobile-logo-wrapper">
      <img src="./assets/logo.png" class="logo" />
    </li>
        <li ><router-link  to="/" ><i class="material-icons left">home</i>Home</router-link></li>
        <li ><router-link  :to="{ name: 'services', params: {service: 'default' } }" ><i class="material-icons left">view_list</i>Services</router-link></li>
        <li ><router-link  to="/about" ><i class="material-icons left">highlight</i>About</router-link></li>
        <li ><router-link  to="/contact"><i class="material-icons left">local_phone</i>Contact</router-link></li>
        <li ><router-link  to="/policy"><i class="material-icons left">note</i>Privacy Policy</router-link></li>
        <li ><a href="https://panel.kcco.co.in/" style="color:#000000;font-weight:500"><i class="material-icons left">login</i>Login</a></li>
  </ul>
</div>
 <transition name="fade">
    <router-view/>
  </transition>
         <footer class="page-footer" style="background:#3e4551">
          <div class="container">
            <div class="row">
              <div class="col l6 s12">
                <h5 class="white-text">Contact Us</h5>
                <p class="grey-text text-lighten-4" style="font-size:12px;"> Office I-  H-06/117, Aggarwal Tower, Netaji Subhash Place, Pitampura, New Delhi-110034<br>Office II-  B-19, East Krishna Nagar, Delhi- 110051<br>Office III-  Khasra No-79, Near HDFC Bank, Main Market, Kalka Shimla Road (NH5), Dharampur, Distt Solan (HP) 173209</p>
                <p class="grey-text text-lighten-4" style="font-size:12px;">Email Address: kartikchugh.co@gmail.com, cakartikchugh@gmail.com, k.chugh@kcco.co.in</p>
                <p class="grey-text text-lighten-4" style="font-size:12px;">Mobile Number: +91-9999-09-8879, +91-11-4587-2080, +91-8468-84-6840</p>
              </div>
              <div class="col l4 offset-l2 s12">
                <h5 class="white-text">Kartik Chugh & Co.</h5>
                 <p v-for="(name) of listItems" v-bind:key="name">
                  <router-link class="grey-text text-lighten-4" :to="{ name: 'services', params: {service: name } }" style="font-size:16px;">{{ name }}</router-link>
                </p>
              </div>
            </div>
          </div>
          
          <div class="footer-copyright">
            <div class="container" style="text-align:center">
            © 2019 All Rights Reserved
            </div>
          </div>
        </footer>   
</div>
</template>

<script>
  import M from "materialize-css";

  export default {
    mounted(){
      var options = {
        alignment: "bottom",
        hover: true,
        inDuration: 500,
        coverTrigger: false,
        constrainWidth: false
      }
      var elems = document.querySelectorAll('.dropdown-trigger');
      var instances = M.Dropdown.init(elems, options);
      this.listItems = this.$store.listItems;
      
      var elems = document.querySelectorAll('.sidenav');
      var instances = M.Sidenav.init(elems, options);
      // M.AutoInit();
    },
    updated() {
      // M.AutoInit();
    },
    data(){
      return{
        dropDownVisible: false,
        listItems: []
      }
    },  
    methods: {
      toggleDropDown(){
        this.dropDownVisible = !this.dropDownVisible
        console.log(this.dropDownVisible)
      }
    },
    components:{
      
    }
  }
</script>

<style scoped>

.services-wrapper{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  margin:7% auto;
}

.logo{
  width:58px;
  background: white;
  border-radius: 12px;
  padding: 6px;
}
.logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0px 10px;
}
.mobile-logo-wrapper{
  padding:20px;
   display: flex;
    align-items: center;
    justify-content: center;
}

.btn {
    text-transform: none;
    background-color:transparent;
    color:#ffffff;
    font-weight:600;
    font-family: 'Montserrat', sans-serif;  
}

</style>

